import * as React from 'react';
import styled from '@emotion/styled';

import { Link } from '>shared/components/actions/link';
import {
  languageToLabel,
  languageToLocale,
  allowedLanguages,
  localeToLanguage,
} from '>shared/lib/language';

import { ButtonContainer } from '>components/styles/policy.styles';
import { useTranslation } from 'react-i18next';

const LanguageSelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const LanguageSelector: React.FC<{}> = () => {
  const { i18n } = useTranslation();

  const languagesToDisplay = React.useMemo(() => {
    return allowedLanguages.filter((language) => language !== localeToLanguage(i18n.language));
  }, [i18n.language]);

  return (
    <LanguageSelectionContainer>
      {languagesToDisplay.map((lng, i) => (
        <ButtonContainer key={`${lng}-${i}`}>
          <Link
            onClick={() => {
              const locale = languageToLocale(lng);
              i18n.changeLanguage(locale);
            }}
          >
            {languageToLabel(lng)}
          </Link>
        </ButtonContainer>
      ))}
    </LanguageSelectionContainer>
  );
};

export default LanguageSelector;
